import { cascaderCarType } from '../../common/utils/typeDict';
import { destruct } from '@aximario/json-tree';
export let props = ['width','placeholder','value'];
export let model = {
  cascaderCarType,
  cascaderCarTypeFlat:destruct(cascaderCarType, {
    id: 'value',
    pid: 'parentValue',
    children: 'children'
  }),
  modelValue: {},
};
export let computed = {
  _value: {
    get() {
      if(!this.value){
        return undefined;
      }
      return this.modelValue;
    },
    set(v) {
      this.modelValue = v;
      this.$emit('input', this.modelValue ? (this.modelValue.value ? this.modelValue.value : undefined) : undefined);
    }
  }
};
